module.exports = __webpack_public_path__ + "img/dashboard-bg.1ff9a12b.png";